import React from 'react';
//import PropTypes from 'prop-types';
import ParallaxElement from '../common/ParallaxElement';

export default class FlameSwords extends React.PureComponent {
    static propTypes = {};

    componentDidMount() {
        //this.flameAnimation();
    }

    flameAnimation = () => {
        TweenMax.from(this.body, 3, {
            y: 1, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.from(this.head, 3, {
            y: 1, rotation: 3, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.to(this.rightArm, 3, {
            y: 1, x: -8, rotation: -71, repeat: -1, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
        TweenMax.to(this.leftArm, 3, {
            y: 5, x: -10, rotation: -10, repeat: -1, delay: 0.5, yoyo: true, ease: Power2.easeInOut
        });
    };
    render() {
        return (
            <ParallaxElement
                yStrength={0} stopX={5} xStrength={0.1} id="flame"
                xAnimateFromLeft>
                <div id="flame-wrapper" className="flameWrapper">
                    <div ref={(c) => {this.rightArm = c;}} className="flame rightArm" />
                    <div ref={(c) => {this.body = c;}} className="flame body" />
                    <div ref={(c) => {this.head = c;}} className="flame head" />
                    <div ref={(c) => {this.leftArm = c;}} className="flame leftArm" />
                </div>
            </ParallaxElement>
        );
    }
}

